import { render, staticRenderFns } from "./modal-look.vue?vue&type=template&id=6a8fbd3a&scoped=true"
import script from "./modal-look.vue?vue&type=script&lang=js"
export * from "./modal-look.vue?vue&type=script&lang=js"
import style0 from "./modal-look.vue?vue&type=style&index=0&id=6a8fbd3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8fbd3a",
  null
  
)

export default component.exports